// CodeHighlighter.jsx
// Χρήση: import CodeHighlighter from 'components/CodeHighlighter';
// <CodeHighlighter code={generateCode()} language={codeLanguage} />

import React from 'react';

// VS Code Dark+ theme exact colors
const VSCODE = {
    keyword:     '#569cd6', // blue     - const, def, class, new, import...
    keyword2:    '#c586c0', // pink     - return, if, else, for, while...
    string:      '#ce9178', // orange   - "hello"
    comment:     '#6a9955', // green    - // comment, # comment
    number:      '#b5cea8', // lt green - 0, 1, 2...
    function:    '#dcdcaa', // yellow   - function/method calls
    className:   '#4ec9b0', // teal     - class names, types
    type:        '#4ec9b0', // teal     - int, bool, String...
    parameter:   '#9cdcfe', // lt blue  - variables, parameters
    property:    '#9cdcfe', // lt blue  - .property access
    operator:    '#d4d4d4', // grey     - = > < ! + -
    punctuation: '#d4d4d4', // grey     - { } ( ) [ ] ; ,
    include:     '#c586c0', // pink     - #include, #define
    namespace:   '#4ec9b0', // teal     - std, cout, cin
    decorator:   '#dcdcaa', // yellow   - @decorator, @Override
    annotation:  '#dcdcaa', // yellow   - @Override
    builtin:     '#dcdcaa', // yellow   - built-in methods
    default:     '#d4d4d4', // grey     - everything else
};

const PATTERNS = {
    javascript: [
        { type: 'comment',     regex: /(\/\/[^\n]*)/ },
        { type: 'comment',     regex: /(\/\*[\s\S]*?\*\/)/ },
        { type: 'string',      regex: /("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|`(?:[^`\\]|\\.)*`)/ },
        { type: 'keyword',     regex: /\b(const|let|var|class|new|this|typeof|instanceof|import|export|default|extends|super|static|async|await|of|in)\b/ },
        { type: 'keyword2',    regex: /\b(return|if|else|for|while|do|break|continue|switch|case|try|catch|finally|throw|function|get|set)\b/ },
        { type: 'keyword',     regex: /\b(true|false|null|undefined|NaN|Infinity)\b/ },
        { type: 'className',   regex: /\b([A-Z][a-zA-Z0-9_]*)\b/ },
        { type: 'builtin',     regex: /\b(constructor|push|pop|shift|unshift|splice|slice|sort|map|filter|reduce|forEach|find|findIndex|includes|indexOf|join|split|length|toString|valueOf|keys|values|entries|assign|freeze|create)\b/ },
        { type: 'number',      regex: /\b(\d+\.?\d*)\b/ },
        { type: 'function',    regex: /\b([a-z_][a-zA-Z0-9_]*)\s*(?=\()/ },
        { type: 'operator',    regex: /(===|!==|=>|>=|<=|&&|\|\||[=+\-*/<>!%])/ },
        { type: 'punctuation', regex: /([{}()\[\];,])/ },
        { type: 'property',    regex: /\.([a-zA-Z_][a-zA-Z0-9_]*)/ },
    ],
    python: [
        { type: 'comment',     regex: /(#[^\n]*)/ },
        { type: 'string',      regex: /("""[\s\S]*?"""|'''[\s\S]*?'''|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/ },
        { type: 'decorator',   regex: /(@[a-zA-Z_][a-zA-Z0-9_]*)/ },
        { type: 'keyword',     regex: /\b(import|from|as|class|def|lambda|with|yield|global|nonlocal|del|assert|raise|pass|self)\b/ },
        { type: 'keyword2',    regex: /\b(return|if|elif|else|for|while|break|continue|try|except|finally|in|is|and|or|not)\b/ },
        { type: 'keyword',     regex: /\b(True|False|None)\b/ },
        { type: 'className',   regex: /\b([A-Z][a-zA-Z0-9_]*)\b/ },
        { type: 'builtin',     regex: /\b(print|len|range|sorted|reversed|enumerate|zip|map|filter|list|dict|set|tuple|str|int|float|bool|type|isinstance|super|append|pop|insert|remove|extend|clear|copy|update|get|items|keys|values|heappush|heappop)\b/ },
        { type: 'number',      regex: /\b(\d+\.?\d*)\b/ },
        { type: 'function',    regex: /\b([a-z_][a-zA-Z0-9_]*)\s*(?=\()/ },
        { type: 'operator',    regex: /(==|!=|>=|<=|->|[=+\-*\/<>!%])/ },
        { type: 'punctuation', regex: /([{}()\[\]:,])/ },
        { type: 'property',    regex: /\.([a-zA-Z_][a-zA-Z0-9_]*)/ },
    ],
    java: [
        { type: 'comment',     regex: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)/ },
        { type: 'string',      regex: /("(?:[^"\\]|\\.)*")/ },
        { type: 'annotation',  regex: /(@[A-Za-z]+)/ },
        { type: 'keyword',     regex: /\b(class|interface|extends|implements|new|this|super|static|final|abstract|synchronized|volatile|import|package|instanceof|enum)\b/ },
        { type: 'keyword2',    regex: /\b(public|private|protected|return|if|else|for|while|do|break|continue|switch|case|try|catch|finally|throw|throws)\b/ },
        { type: 'keyword',     regex: /\b(true|false|null)\b/ },
        { type: 'type',        regex: /\b(int|boolean|char|double|float|long|short|byte|void|String|var)\b/ },
        { type: 'className',   regex: /\b([A-Z][a-zA-Z0-9_]*)\b/ },
        { type: 'builtin',     regex: /\b(add|remove|get|size|isEmpty|sort|contains|clear|put|values|keySet|toString|equals|hashCode|compareTo|println|printf|parseInt|valueOf|length|charAt|substring|replace|trim|split)\b/ },
        { type: 'number',      regex: /\b(\d+\.?\d*)\b/ },
        { type: 'function',    regex: /\b([a-z_][a-zA-Z0-9_]*)\s*(?=\()/ },
        { type: 'operator',    regex: /(==|!=|>=|<=|&&|\|\||[=+\-*\/<>!%])/ },
        { type: 'punctuation', regex: /([{}()\[\];,])/ },
        { type: 'property',    regex: /\.([a-zA-Z_][a-zA-Z0-9_]*)/ },
    ],
    cpp: [
        { type: 'comment',     regex: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)/ },
        { type: 'string',      regex: /("(?:[^"\\]|\\.)*")/ },
        { type: 'include',     regex: /(#\s*(?:include|define|pragma|ifndef|ifdef|endif|if|else)[^\n]*)/ },
        { type: 'keyword',     regex: /\b(struct|class|namespace|using|typedef|template|typename|new|delete|this|operator|explicit|inline|virtual|override|public|private|protected|friend|static|const|constexpr|auto|extern|mutable|enum)\b/ },
        { type: 'keyword2',    regex: /\b(return|if|else|for|while|do|break|continue|switch|case|try|catch|throw)\b/ },
        { type: 'keyword',     regex: /\b(true|false|nullptr|NULL)\b/ },
        { type: 'type',        regex: /\b(void|bool|int|char|double|float|long|short|unsigned|signed|size_t|wchar_t)\b/ },
        { type: 'namespace',   regex: /\b(std|cout|cin|cerr|endl)\b/ },
        { type: 'className',   regex: /\b([A-Z][a-zA-Z0-9_]*)\b/ },
        { type: 'builtin',     regex: /\b(push_back|pop_back|back|front|empty|size|begin|end|sort|find|erase|insert|clear|resize|reserve|at|swap|make_pair|push|pop|top)\b/ },
        { type: 'number',      regex: /\b(\d+\.?\d*)\b/ },
        { type: 'function',    regex: /\b([a-z_][a-zA-Z0-9_]*)\s*(?=\()/ },
        { type: 'operator',    regex: /(::|-&gt;|->|==|!=|>=|<=|&&|\|\||[=+\-*\/<>!%&|^~])/ },
        { type: 'punctuation', regex: /([{}()\[\];,])/ },
        { type: 'property',    regex: /\.([a-zA-Z_][a-zA-Z0-9_]*)/ },
    ],
};

const tokenize = (line, language) => {
    const patterns = PATTERNS[language] || PATTERNS.javascript;
    const tokens = [];
    let remaining = line;

    while (remaining.length > 0) {
        let matched = false;

        for (const { type, regex } of patterns) {
            const fullRegex = new RegExp('^' + regex.source);
            const match = remaining.match(fullRegex);
            if (match) {
                if (type === 'property' && match[0].startsWith('.')) {
                    tokens.push({ value: '.', style: { color: VSCODE.punctuation } });
                    tokens.push({ value: match[0].slice(1), style: { color: VSCODE.property } });
                } else {
                    tokens.push({ value: match[0], style: { color: VSCODE[type] || VSCODE.default } });
                }
                remaining = remaining.slice(match[0].length);
                matched = true;
                break;
            }
        }

        if (!matched) {
            tokens.push({ value: remaining[0], style: { color: VSCODE.default } });
            remaining = remaining.slice(1);
        }
    }

    return tokens;
};

const CodeHighlighter = ({ code, language }) => {
    if (!code) return null;

    const lines = code.split('\n');

    return (
        <pre style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            fontFamily: "'Fira Code', 'Cascadia Code', 'Consolas', 'Monaco', monospace",
            fontSize: 'inherit',
            lineHeight: 'inherit',
        }}>
            {lines.map((line, lineIdx) => (
                <div key={lineIdx}>
                    {tokenize(line, language).map((token, i) => (
                        <span key={i} style={token.style}>{token.value}</span>
                    ))}
                </div>
            ))}
        </pre>
    );
};

export default CodeHighlighter;